export default class Hotjar {
    init (config = {}) {
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments)
            }
            h._hjSettings = {hjid: config.hjid, hjsv: config.hjsv}
            a = o.getElementsByTagName('head')[0]
            r = o.createElement('script')
            r.async = 1
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
            a.appendChild(r)
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
    }

    trackView () { /* Overriden by modules */ }

    trackEvent () { /* Overriden by modules */ }

    trackException () { /* Overriden by modules */ }

    trackTiming () { /* Overriden by modules */ }

    setAlias () { /* Overriden by modules */ }

    identify (obj) {}

    setUsername () { /* Overriden by modules */ }

    setUserProperties (obj) {
        window.hj('tagRecording', [obj.email])
    }

    setUserPropertiesOnce () { /* Overriden by modules */ }

    incrementUserProperties () { /* Overriden by modules */ }

    setSuperProperties (obj) {
        window.hj('tagRecording', [obj.name])
    }

    setSuperPropertiesOnce () { /* Overriden by modules */ }

    ecommerceTrackEvent () { /* Overriden by modules */ }

    addTransaction () { /* Overriden by modules */ }

    addItem () { /* Overriden by modules */ }

    trackTransaction () { /* Overriden by modules */ }

    clearTransactions () { /* Overriden by modules */ }

    reset () { /* Overriden by modules */ }
}



// WEBPACK FOOTER //
// ./src/analitycs/hotjar.js